import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxOA2OA extends Component {
  render() {
    return (
      <Inbox type='OA2OA'/>
    );
  }
}
